module.exports = __webpack_public_path__ + "img/arrow.ebf27ee1.svg";